import React, { ReactElement } from 'react';

import { StyleSheet, useWindowDimensions } from 'react-native';

import LoadingAnimation from 'components/loading-animation';
import { Box, Typography } from 'components/ui';
import { primitive } from 'styles/constants';
import { breakpoints } from 'styles/constants/breakpoints';

const getAuthButtonWidth = (windowWidth: number) => {
  if (windowWidth >= breakpoints.md) {
    return 500;
  }

  if (windowWidth >= breakpoints.sm) {
    return 420;
  }

  return 355;
};

const AuthButton = ({
  icon,
  label,
  loading,
}: {
  icon: ReactElement;
  label: string;
  loading: boolean;
}) => {
  const { width } = useWindowDimensions();

  return (
    <Box style={[styles.buttonContainer, { maxWidth: getAuthButtonWidth(width) }]}>
      <Box style={styles.iconContainer}>
        {loading ? <LoadingAnimation size="sm" mr="$1" /> : icon}
      </Box>
      <Typography color={primitive.$bbqBrown} style={styles.label}>
        {label}
      </Typography>
    </Box>
  );
};

export default AuthButton;

const styles = StyleSheet.create({
  buttonContainer: {
    alignContent: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
  iconContainer: {
    alignContent: 'center',
    height: 24,
    justifyContent: 'center',
    width: 24,
  },
  label: {
    alignSelf: 'center',
  },
});
